import { VerificationNames } from "shared/types";

export const mergeHousingHistoryVerifications = <
  T extends { name: VerificationNames; title?: string }
>(
  verifications: T[]
): T[] => {
  const premium = verifications.find(
    (v) => v.name === VerificationNames.PremiumRentalHistory
  );
  if (!premium) return verifications;

  const standard = verifications.find(
    (v) => v.name === VerificationNames.HousingHistory
  );

  const rest = verifications.filter(
    (v) =>
      v.name !== VerificationNames.PremiumRentalHistory &&
      v.name !== VerificationNames.HousingHistory
  );

  if (standard) return [...rest, standard];

  return [...rest, { ...premium, name: VerificationNames.HousingHistory } as T];
};
